import './App.css'

import {ModalProvider, ToasterContainer} from 'exsportia-components'
import React from 'react'

import {ExternalLinkGate} from './components/external-link-gate/external-link-gate'
import {Router} from './navigation'
import {QueryClientProvider} from './networking/query-client-provider'
import {Redux} from './redux'
import {Theme} from './theme'

export const App = () => {
  return (
    <Redux>
      <Theme>
        <ToasterContainer />
        <QueryClientProvider>
          <ModalProvider>
            <ExternalLinkGate />
            <Router />
          </ModalProvider>
        </QueryClientProvider>
      </Theme>
    </Redux>
  )
}
